"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersScreen = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var get_all_client_users_1 = require("../../../api/calls/users/get_all_client_users");
var main_1 = require("../../../reducers/slices/main");
var details_1 = require("./details");
var delete_user_1 = require("../../../api/calls/users/v3/delete_user");
var export_user_emails_csv_1 = require("../../../api/calls/client/export_user_emails_csv");
var lodash_1 = require("lodash");
var UsersScreen = function (props) {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var selectedClient = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClient;
    var _b = (0, react_1.useState)([]), users = _b[0], setUsers = _b[1];
    var _c = (0, react_1.useState)(0), currentPage = _c[0], setCurrentPage = _c[1];
    var _d = (0, react_1.useState)(10), rowsPerPage = _d[0], setRowsPerPage = _d[1];
    var _e = (0, react_1.useState)(false), isLoading = _e[0], setIsLoading = _e[1];
    (0, react_1.useEffect)(function () {
        if (selectedClient && selectedClient.entity_id) {
            refreshUsers();
        }
    }, [selectedClient]);
    var refreshUsers = function (page, limit) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 10; }
        setIsLoading(true);
        (0, get_all_client_users_1.get_all_client_users)(selectedClient.entity_id, { page: page, limit: limit }).then(function (response) {
            var _a, _b, _c, _d, _e;
            if (response.data.success) {
                setUsers((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.users);
                setTotalRecords((_e = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.totalRecords) !== null && _e !== void 0 ? _e : 0);
            }
            else {
                dispatch((0, main_1.setMessageModal)({ title: "Users", messages: [response.data.message] }));
            }
            setIsLoading(false);
        });
    };
    // const refreshUsers = async () => {
    //   setIsLoading(true);
    //   const response = await get_all_client_users(selectedClient.entity_id);
    // await new Promise(resolve => setTimeout(resolve, 20000));
    //   if (response.data.success) {
    //     console.log(response.data.content, "content")
    //     setUsers(response.data.content);
    //   } else {
    //     dispatch(setMessageModal({ title: "Users", messages: [response.data.message] }));
    //   }
    //   setIsLoading(false); 
    // };
    var _f = (0, react_1.useState)([]), filteredData = _f[0], setFilteredData = _f[1];
    var _g = (0, react_1.useState)(""), searchText = _g[0], setSearchText = _g[1];
    var _h = (0, react_1.useState)(1), totalRecords = _h[0], setTotalRecords = _h[1];
    var debouncedSearch = (0, react_1.useMemo)(function () { return (0, lodash_1.debounce)(function (text) {
        var lowerSearch = text.toLowerCase();
        var results = users.filter(function (item) {
            var _a, _b, _c;
            return (((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith(lowerSearch)) ||
                ((_b = item.surname) === null || _b === void 0 ? void 0 : _b.toLowerCase().startsWith(lowerSearch)) ||
                ((_c = item.email) === null || _c === void 0 ? void 0 : _c.toLowerCase().startsWith(lowerSearch)));
        });
        setFilteredData(results);
    }, 300); }, [users]);
    (0, react_1.useEffect)(function () {
        if (searchText === "") {
            setFilteredData([]);
        }
        else if (users.length > 0) {
            debouncedSearch(searchText);
        }
        // Cleanup debounce on unmount
        return function () {
            debouncedSearch.cancel();
        };
    }, [searchText, users, debouncedSearch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "flex flex-col gap-4 p-4" },
            react_1.default.createElement(react_router_dom_1.Routes, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement("div", { className: "flex flex-row" },
                            react_1.default.createElement("div", { className: "text-2xl font-bold flex-1" },
                                "Users for ", (_a = selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.name) !== null && _a !== void 0 ? _a : "[select a client]")),
                        react_1.default.createElement("div", { className: "flex gap-4" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Manually Create User", backgroundColor: "bg-green-600", size: "small", onClick: function () {
                                    if (selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id) {
                                        // dispatch(setContentModal({ title: "Create User", content: <UserDetailsPage refreshUsers={refreshUsers} /> }));
                                        navigate("".concat(pathname, "/user"));
                                    }
                                    else {
                                        dispatch((0, main_1.setMessageModal)({ title: "Create User", messages: ["First select a client to create a user for."] }));
                                    }
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Export Emails CSV", backgroundColor: "bg-cyan-500", size: "small", onClick: function () {
                                    if (selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id) {
                                        (0, export_user_emails_csv_1.export_user_emails_csv)({
                                            client_entity_id: selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id,
                                        }).then(function (response) {
                                            if (response.data.success) {
                                                var csv = response.data.content;
                                                var element = document.createElement("a");
                                                var file = new Blob([csv], { type: "text/csv" });
                                                element.style.display = "none";
                                                element.href = URL.createObjectURL(file);
                                                element.download = "client_user_emails_export.csv";
                                                element.click();
                                                element.remove();
                                            }
                                        });
                                    }
                                    else {
                                        dispatch((0, main_1.setMessageModal)({ title: "Export Emails CSV", messages: ["First select a client to export user emails."] }));
                                    }
                                } })),
                        isLoading ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                            react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null))) : (react_1.default.createElement(doshx_controls_web_1.TableControl
                        // title="Users"
                        , { 
                            // title="Users"
                            onSearch: function (text) { return setSearchText(text); }, columns: [
                                { label: "Name", displayKey: "name" },
                                { label: "Surname", displayKey: "surname" },
                                { label: "Email", displayKey: "email" },
                                {
                                    label: "Phone Number",
                                    displayKey: "",
                                    formatter: function (obj) {
                                        var _a, _b;
                                        //                       console.log("obj", obj);
                                        return "".concat((_a = obj.cell_phone) === null || _a === void 0 ? void 0 : _a.calling_code).concat((_b = obj.cell_phone) === null || _b === void 0 ? void 0 : _b.number);
                                    },
                                },
                            ], data: filteredData && filteredData.length ? filteredData : users, 
                            // onSearch={(search) => {
                            //   console.log("search", search);
                            // }}
                            pagination: {
                                totalRecords: totalRecords,
                                paginationPosition: "right",
                                rowsPerPage: rowsPerPage,
                                currentPage: currentPage,
                                onPageChange: function (page) {
                                    if (page !== currentPage) {
                                        setCurrentPage(page);
                                        refreshUsers(page, rowsPerPage);
                                    }
                                },
                                onRowsPerPageChange: function (rows) {
                                    setRowsPerPage(rows);
                                    setCurrentPage(1);
                                    refreshUsers(1, rows);
                                },
                                rowsPerPageOptions: [10, 20, 30, 50],
                            }, onRowClicked: function (row) {
                                navigate("".concat(pathname, "/user/").concat(row.entity_id));
                            }, rowActions: [
                                {
                                    label: "Delete",
                                    onClick: function (row) {
                                        dispatch((0, main_1.setMessageModal)({
                                            title: "Delete User Account",
                                            messages: ["Are you sure you want to delete this user account?"],
                                            buttons: "yesNo",
                                            onConfirm: function () {
                                                (0, delete_user_1.delete_user)({
                                                    user_entity_id: row.entity_id,
                                                }).then(function (e) {
                                                    refreshUsers();
                                                    dispatch((0, main_1.setMessageModal)(null));
                                                });
                                            },
                                        }));
                                    },
                                },
                            ], colors: {
                                titleBackgroundColor: "bg-blue-600",
                                headerBackgroundColor: "bg-bluish",
                                headerTextColor: "text-white",
                                ordering: {
                                    borderColor: "border-bluish",
                                },
                                hoverRowColor: "hover:bg-gray-200",
                            } }))) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/user/:user_entity_id?", element: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "flex flex-row" },
                            react_1.default.createElement("div", { className: "text-2xl font-bold flex-1" }, "User Details")),
                        react_1.default.createElement(details_1.UserDetailsPage, { onSuccess: function () {
                                refreshUsers();
                            } })) })))));
};
exports.UsersScreen = UsersScreen;
// import { ButtonControl, ShimmerBoxControl, TableControl } from "doshx_controls_web";
// import React, { useState, useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import { get_all_client_users } from "../../../api/calls/users/get_all_client_users";
// import { IClientSliceState } from "../../../reducers/slices/client";
// import { setMessageModal, setContentModal } from "../../../reducers/slices/main";
// import { UserDetailsPage } from "./details";
// import { delete_user } from "../../../api/calls/users/v3/delete_user";
// import { export_user_emails_csv } from "../../../api/calls/client/export_user_emails_csv";
// import { debounce } from "lodash";
// import Loader from "../live/common/loader";
// const UsersScreen = (props) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { pathname } = useLocation();
//   const { selectedClient } = useSelector<any, IClientSliceState>((state) => state.clientState);
//   const [users, setUsers] = useState<any>([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   useEffect(() => {
//     if (selectedClient && selectedClient.entity_id) {
//       refreshUsers();
//     }
//   }, [selectedClient]);
//   const refreshUsers = (page = 1, limit = 10) => {
//     setIsLoading(true);
//     get_all_client_users(selectedClient.entity_id, { page, limit }).then((response) => {
//       if (response.data.success) {
//         setUsers(response?.data?.content?.users);
//         setTotalRecords(response?.data?.content?.totalRecords ?? 0); // Set this in state
//       } else {
//         dispatch(setMessageModal({ title: "Users", messages: [response.data.message] }));
//       }
//       setIsLoading(false);
//     });
//   };
//   const [filteredData, setFilteredData] = useState<any>([]);
//   const [searchText, setSearchText] = useState("");
//   const [totalRecords, setTotalRecords] = useState(1);
//   const debouncedSearch = useMemo(
//     () =>
//       debounce((text) => {
//         const lowerSearch = text.toLowerCase();
//         const results = users.filter((item) => {
//           return (
//             item.name?.toLowerCase().startsWith(lowerSearch) ||
//             item.surname?.toLowerCase().startsWith(lowerSearch) ||
//             item.email?.toLowerCase().startsWith(lowerSearch)
//           );
//         });
//         setFilteredData(results);
//       }, 300),
//     [users],
//   );
//   useEffect(() => {
//     if (searchText === "") {
//       setFilteredData([]);
//     } else if (users.length > 0) {
//       debouncedSearch(searchText);
//     }
//     // Cleanup debounce on unmount
//     return () => {
//       debouncedSearch.cancel();
//     };
//   }, [searchText, users, debouncedSearch]);
//   return (
//     <>
//       {/* {isLoading && <Loader/>} */}
//       <div className="flex flex-col gap-4 p-4">
//         <Routes>
//           <Route
//             path="/"
//             element={
//               <div className="flex flex-col gap-4">
//                 <div className="flex flex-row">
//                   <div className="text-2xl font-bold flex-1">Users for {selectedClient?.name ?? "[select a client]"}</div>
//                 </div>
//                 <div className="flex gap-4">
//                   <ButtonControl
//                     label="Manually Create User"
//                     backgroundColor="bg-green-600"
//                     size="small"
//                     onClick={() => {
//                       if (selectedClient?.entity_id) {
//                         // dispatch(setContentModal({ title: "Create User", content: <UserDetailsPage refreshUsers={refreshUsers} /> }));
//                         navigate(`${pathname}/user`);
//                       } else {
//                         dispatch(setMessageModal({ title: "Create User", messages: ["First select a client to create a user for."] }));
//                       }
//                     }}
//                   />
//                   <ButtonControl
//                     label="Export Emails CSV"
//                     backgroundColor="bg-cyan-500"
//                     size="small"
//                     onClick={() => {
//                       if (selectedClient?.entity_id) {
//                         export_user_emails_csv({
//                           client_entity_id: selectedClient?.entity_id,
//                         }).then((response) => {
//                           if (response.data.success) {
//                             const csv = response.data.content;
//                             const element = document.createElement("a");
//                             const file = new Blob([csv], { type: "text/csv" });
//                             element.style.display = "none";
//                             element.href = URL.createObjectURL(file);
//                             element.download = "client_user_emails_export.csv";
//                             element.click();
//                             element.remove();
//                           }
//                         });
//                       } else {
//                         dispatch(setMessageModal({ title: "Export Emails CSV", messages: ["First select a client to export user emails."] }));
//                       }
//                     }}
//                   />
//                 </div>
//                 {isLoading ? (
//                   <div className="flex flex-col gap-4">
//                     <ShimmerBoxControl />
//                   </div>
//                 ) : (
//                   <TableControl
//                     // title="Users"
//                     onSearch={(text: string) => setSearchText(text)}
//                     columns={[
//                       { label: "Name", displayKey: "name" },
//                       { label: "Surname", displayKey: "surname" },
//                       { label: "Email", displayKey: "email" },
//                       {
//                         label: "Phone Number",
//                         displayKey: "",
//                         formatter: (obj) => {
//                           console.log("obj", obj);
//                           return `${obj.cell_phone?.calling_code}${obj.cell_phone?.number}`;
//                         },
//                       },
//                     ]}
//                     data={filteredData && filteredData.length ? filteredData : users}
//                     pagination={{
//                       totalRecords: totalRecords,
//                       paginationPosition: "right",
//                       rowsPerPage: rowsPerPage,
//                       currentPage: currentPage,
//                       onPageChange: (page) => {
//                         if (page !== currentPage) {
//                           setCurrentPage(page);
//                           refreshUsers(page, rowsPerPage);
//                         }
//                       },
//                       onRowsPerPageChange: (rows) => {
//                         setRowsPerPage(rows);
//                         setCurrentPage(1); 
//                         refreshUsers(1, rows); 
//                       },
//                       rowsPerPageOptions: [10, 20, 30, 50],
//                     }}
//                     // onSearch={(search) => {
//                     //   console.log("search", search);
//                     // }}
//                     // pagination={{
//                     //   totalRecords: users.length,
//                     //   paginationPosition: "left",
//                     //   rowsPerPage: rowsPerPage,
//                     //   currentPage: currentPage,
//                     //   onPageChange: (page) => {
//                     //     setCurrentPage(page);
//                     //   },
//                     //   onRowsPerPageChange: (rows) => {
//                     //     setRowsPerPage(rows);
//                     //   },
//                     // }}
//                     onRowClicked={(row) => {
//                       navigate(`${pathname}/user/${row.entity_id}`);
//                     }}
//                     rowActions={[
//                       {
//                         label: "Delete",
//                         onClick: (row) => {
//                           dispatch(
//                             setMessageModal({
//                               title: "Delete User Account",
//                               messages: ["Are you sure you want to delete this user account?"],
//                               buttons: "yesNo",
//                               onConfirm: () => {
//                                 delete_user({
//                                   user_entity_id: row.entity_id,
//                                 }).then((e) => {
//                                   refreshUsers();
//                                   dispatch(setMessageModal(null));
//                                 });
//                               },
//                             }),
//                           );
//                         },
//                       },
//                     ]}
//                     colors={{
//                       titleBackgroundColor: "bg-blue-600",
//                       headerBackgroundColor: "bg-bluish",
//                       headerTextColor: "text-white",
//                       ordering: {
//                         borderColor: "border-bluish",
//                       },
//                       hoverRowColor: "hover:bg-gray-200",
//                     }}
//                   />
//                 )}
//               </div>
//             }
//           />
//           <Route
//             path={`/user/:user_entity_id?`}
//             element={
//               <>
//                 <div className="flex flex-row">
//                   <div className="text-2xl font-bold flex-1">User Details</div>
//                 </div>
//                 <UserDetailsPage
//                   onSuccess={() => {
//                     refreshUsers();
//                   }}
//                 />
//               </>
//             }
//           />
//         </Routes>
//       </div>
//     </>
//   );
// };
// export { UsersScreen };
